import { useEffect, useState } from 'react';

/**
 * Spårar scroll-riktning för auto-hide UI.
 *
 * Returnerar `hidden = true` när användaren scrollar ner förbi tröskeln.
 * Sätts tillbaka till `false` när användaren scrollar upp ens lite (delta>4px).
 *
 * `topOffset` = pixel-höjd över vilken auto-hide aktiveras (under den ska
 * UI alltid synas — t.ex. överst på sidan ska filter alltid visas).
 */
export function useScrollDirection(topOffset = 100) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    function update() {
      const y = window.scrollY;
      const delta = y - lastY;

      if (y < topOffset) {
        // Nära toppen: alltid visa
        setHidden(false);
      } else if (delta > 8) {
        // Scroll ner: göm
        setHidden(true);
      } else if (delta < -4) {
        // Scroll upp (även lite): visa
        setHidden(false);
      }

      lastY = y;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [topOffset]);

  return hidden;
}
